import { render, staticRenderFns } from "./PromotionRules.vue?vue&type=template&id=92d5d416"
import script from "./PromotionRules.vue?vue&type=script&lang=js"
export * from "./PromotionRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports